import React, { useEffect } from "react";

import {Loginpage} from "./pages/LoginPage/LoginPage";
import {PricingListPage} from "./pages/PricingListPage/PricingListPage";
import {DealPage} from "./pages/DealPage/DealPage";
import {AuthContextProvider, useAuthContext} from "./contexts/AuthContext";
import {Outlet} from "react-router-dom";
import {useLocation} from "react-router-dom";
import {Navigate} from "react-router";
import {HomePage} from "./pages/HomePage/HomePage";
import {ProfilePage} from "./pages/ProfilePage/ProfilePage";
import {UserContextProvider, useUserContext} from "./contexts/UserContext";
import {DealContextProvider} from "./contexts/DealContext";
import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";
import {ListDealsPage} from "./pages/ListDealsPage/ListDealsPage";
import {ErrorBoundaryLogger} from "./components/ErrorBoundaryLogger";
import {ToastContainer} from "react-toastify";
import {UIContextProvider} from "./contexts/UIContext";
import {CalculatePage} from "./pages/CalculatePage/CalculatePage";
import {CalcContextProvider} from "./contexts/CalcContext";
import {toTitleCase} from "./utils/utils";
import {ForbiddenPage} from "./pages/ForbiddenPage/ForbiddenPage";
import {NotFoundPage} from "./pages/NotFoundPage/NotFoundPage";
import {LeadsPage} from "./pages/CRM/LeadsPage/LeadsPage";
import {CRMPage} from "./pages/CRM/CRMPage";
import {LandingPage} from "./pages/LandingPage/LandingPage";
import {ClientsPage} from "./pages/CRM/ClientsPage/ClientsPage";


const DocumentTitleProvider = ({ children }) => {
    let location = useLocation();
    useEffect(function updateDocumentTitle(){
        let suffix = toTitleCase(location.pathname.split('/').join(" "))

        if (suffix === ' ') {
            suffix = 'Desking for brokers, by brokers'
        }

        document.title = `${suffix} - TrueDesking`
    }, [location]);

    return children
}

const PrivateRoute = ({ children }) => {
    const { isAuthenticated } = useAuthContext();
    const location = useLocation();

    return isAuthenticated ? (
        children
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    );
}

const FeatureFlagRoute = ({ name, children }) => {
    const location = useLocation();
    const { isFeatureFlagEnabled } = useUserContext()

    return isFeatureFlagEnabled(name) ? (
        children
    ) : (
        <Navigate to="/calculate" state={{ from: location }} replace />
    );
}

export const routes = [
    {
        element: (
            <React.Fragment>
                <DocumentTitleProvider>
                    <UIContextProvider>
                        <ToastContainer
                            autoClose={2500}
                        />
                        <ErrorBoundaryLogger>
                            <DndProvider backend={HTML5Backend}>
                                    <AuthContextProvider>
                                        <Outlet/>
                                    </AuthContextProvider>
                            </DndProvider>
                        </ErrorBoundaryLogger>
                    </UIContextProvider>
                </DocumentTitleProvider>
            </React.Fragment>
        ),
        children: [
            {
                index: true,
                element: <LandingPage />
            },
            {
                element: (
                    <PrivateRoute>
                        <UserContextProvider>
                            <CalcContextProvider>
                                <HomePage/>
                            </CalcContextProvider>
                        </UserContextProvider>
                    </PrivateRoute>
                ),
                path: "/",
                children: [
                    { index: true, element: <Navigate to="/calculate" replace /> },
                    {
                        path: "/calculate",
                        element: <CalculatePage/>,
                    },
                    {
                        path: "/quotes",
                        element: <ListDealsPage/>,
                    },
                    {
                        path: "/pricing/:make",
                        element: <PricingListPage/>,
                    },
                    {
                        path: "/quotes/:id",
                        element: <DealContextProvider><DealPage isDealPage={true}/></DealContextProvider>,
                    },
                    {
                        path: "/account/profile",
                        element: <ProfilePage/>
                    },
                    { path: '/deals*', element: <Navigate to="/quotes" replace /> },
                    {
                        element: (
                            <FeatureFlagRoute name={'crm'}>
                                <CRMPage/>
                            </FeatureFlagRoute>
                        ),
                        children: [
                            {
                                path: "/clients",
                                element: <ClientsPage/>
                            },
                            {
                                path: "/leads",
                                element: <LeadsPage/>
                            }
                        ]
                    }
                ]
            },
            {
                path: '/login',
                element: <Loginpage/>
            },
            {
                path: '/403',
                element: <ForbiddenPage/>
            },
            {
                path: "/*",
                element: <NotFoundPage />
            },
            {
                path: '/404',
                element: <NotFoundPage/>
            }
        ]
    },
]